if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.content = this.querySelector('.read-more__content');
      this.button = this.querySelector('.read-more__toggle');

      if (!this.content || !this.button) return;

      this.readMoreText = window.accessibilityStrings.readMore;
      this.readLessText = window.accessibilityStrings.readLess;

      this.limit = +this.dataset.limit || 2;

      this.setContentHeight();
      this.button.addEventListener('click', this.onToggleClick.bind(this));

      this.resizeTimeout = null;
      this.bindWindowResize = this.windowResize.bind(this);
      window.addEventListener('resize', debounce(this.bindWindowResize, 150));

      this.setMutationObserver();
    }

    onToggleClick() {
      if (this.hasAttribute('open')) {
        this.classList.add('closing');
        this.setDisableButton(true);
        this.button.textContent = this.readMoreText;
        this.button.setAttribute('aria-label', this.readMoreText);
        this.button.setAttribute('aria-expanded', false);

        setTimeout(() => {
          this.removeAttribute('open');
          this.classList.remove('closing');
          this.setDisableButton(false);
        }, 501);
      } else {
        this.setAttribute('open', true);
        this.setDisableButton(true);
        this.button.textContent = this.readLessText;
        this.button.setAttribute('aria-label', this.readLessText);
        this.button.setAttribute('aria-expanded', true);

        setTimeout(() => {
          this.setDisableButton(false);
        }, 501);
      }
    }

    setContentHeight() {
      const wasOpen = this.hasAttribute('open');
      this.classList.remove('loaded');

      this.setAttribute('open', true);
      requestAnimationFrame(() => {
        this.contentHeight = this.content.getBoundingClientRect().height;
        this.style.setProperty('--max-height', `${Math.ceil(this.contentHeight || 1000)}px`);

        if (!wasOpen) this.removeAttribute('open');
        this.classList.add('loaded');
        this.setClosedHeight();
      });
    }

    setDisableButton(setDisable) {
      if (setDisable) {
        this.button.setAttribute('disabled', true);
        this.button.setAttribute('aria-disabled', true);
      } else {
        this.button.removeAttribute('disabled');
        this.button.setAttribute('aria-disabled', false);
      }
    }

    setClosedHeight() {
      const fontSize = parseFloat(getComputedStyle(this.content).fontSize);
      const lineHeightValue = getComputedStyle(this.content).lineHeight;
      let lineHeight;
      if (lineHeightValue.includes('px')) {
        lineHeight = parseFloat(lineHeightValue) / fontSize;
      } else {
        lineHeight = parseFloat(lineHeightValue);
      }

      this.closedHeight = Math.ceil(this.limit * fontSize * lineHeight);
      this.style.setProperty('--closed-height', `${this.closedHeight}px`);

      if (this.contentHeight <= this.closedHeight) {
        this.classList.add('no-overflow');
        this.setDisableButton(true);
      } else {
        this.classList.remove('no-overflow');
        this.setDisableButton(false);
      }
    }

    windowResize() {
      this.setContentHeight();
    }

    setMutationObserver() {
      const contentUpdateObserver = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          this.setContentHeight();
        }
      });

      const contentUpdateConfig = { childList: true, subtree: true };
      contentUpdateObserver.observe(this.content, contentUpdateConfig);
    }
  }

  customElements.define('read-more', ReadMore);
}
